import React from 'react'
import './index.css'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import useSelector from 'hooks/use-selector'
import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'
import { getSubtotalRemainingBeforeAovUnlockProductVariantSelector } from 'modules/product-variant/redux/selectors/get-subtotal-remaining-before-aov-unlock'
import View from 'components/View'
import { ProgressBarWithIndicatorAndLabels } from 'components/ProgressBarWithIndicatorAndLabels'
import TextSemiBold from 'components/TextSemiBold'

const ANALYTICS_EVENT = {
  SHOW_PRODUCT_AOV_LOCK_PROGRESS_BAR: 'SHOW_PRODUCT_AOV_LOCK_PROGRESS_BAR',
  PRODUCT_AOV_SHOW_MORE_TO_UNLOCK: 'PRODUCT_AOV_SHOW_MORE_TO_UNLOCK',
  CLOSE_PRODUCT_AOV_LOCK_PROGRESS_BAR: 'CLOSE_PRODUCT_AOV_LOCK_PROGRESS_BAR'
}

/**
 * @param aovLock
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductAOVLockProgressBar ({
  aovLock
}) {
  const subtotal = useSelector(getSubtotalCartSelector())
  const subtotalRemainingBeforeUnlock = useSelector(getSubtotalRemainingBeforeAovUnlockProductVariantSelector({ aovLock }))

  const handleMount = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_PRODUCT_AOV_LOCK_PROGRESS_BAR)
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  const progressPercentage = Math.min((subtotal / aovLock) * 100, 100)
  return (
    <>
      <View className='product-aov-lock-progres-bar'>
        <View className='product-aov-lock-progres-bar-content'>
          <View className='product-aov-lock-progres-bar-content-text-and-icon'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M11.4 8.39999L4.19995 18.6L5.99995 22.2H11.4L19.8 10.2L16.8 8.99999L11.4 8.39999Z'
                fill='#FFC1F1'
              />
              <path
                d='M12 16V18M7.5 22H16.5005C18.1573 22 19.5005 20.6569 19.5005 19V11.6667C19.5005 10.0098 18.1573 8.6667 16.5005 8.6667H7.5C5.84315 8.6667 4.5 10.0098 4.5 11.6667V19C4.5 20.6569 5.84315 22 7.5 22ZM15.7504 8.66665V5.75012C15.7504 3.67899 14.0714 2 12.0002 2C9.92911 2 8.25013 3.67899 8.25013 5.75012V8.66665H15.7504ZM13.5 14C13.5 14.8284 12.8284 15.5 12 15.5C11.1716 15.5 10.5 14.8284 10.5 14C10.5 13.1716 11.1716 12.5 12 12.5C12.8284 12.5 13.5 13.1716 13.5 14Z'
                stroke='#191531'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>

            <View className='product-aov-lock-progres-bar-content-text'>
              Add <TextSemiBold>${subtotalRemainingBeforeUnlock}</TextSemiBold> to your cart to unlock this sample.
            </View>

          </View>
          <ProgressBarWithIndicatorAndLabels
            minLabel='$0'
            maxLabel={`$${parseInt(aovLock, 10)}`}
            progress={progressPercentage}
          />
        </View>
      </View>
    </>
  )
}
